"use client";

import { useTranslations } from "next-intl";
import { floorPlan } from "../../../../public/images/three-sixty";
import StepContainer from "./StepContainer";

const StepThree = () => {
  const t = useTranslations("threeSixtySteps.steps");

  return (
    <div className="gs--page-column py-16">
      <StepContainer
        title={t("step3.title")}
        text={t("step3.text")}
        src={floorPlan}
        alt={"Schwarz Weiß Grundriss Beispiel"}
        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 350vw, 300vw"
      />
    </div>
  );
};

export default StepThree;
